module.exports = __webpack_public_path__ + "static/media/doc.87ac1e95.svg";